import {
  LOAD_CONVERSATION,
  LOAD_LONG_TRANSACTION,
  SHOW_CONVERSATION,
  START_ALL_TICKET_LQ,
  START_ESCALATED_TICKET_LQ,
  START_ONLOAD_LIVE_QUERY,
} from 'actions/types';
import { startAssignedLiveQuery } from './conversations/assignedLiveQueryGraphQL';
import { startAllLiveQuery } from './conversations/allLiveQueryGraphQL';
import { startEscalatedLiveQuery } from './conversations/escalatedLiveQueryGraphQL';
import { startBusinessDetailLiveQuery } from './businessDetail/businessDetailLiveQueryGraphQL';
import { startReviewTicketsQuery } from './conversations/reviewTicketsLiveQueryGraphQL';
import { startDecisionFlowLiveQuery } from './decisionFlow/decisionFlowLiveQueryGraphQL';
import { startNominatedLiveQuery } from './conversations/nominatedLiveQueryGraphQL';
import { startConversationLiveQuery } from './conversations/messageLiveQueryGraphQL';
import { startLongTransactionLiveQuery } from './longTransaction/longTransactionLiveQueryGraphQL';

const liveQueryMiddleware = function () {
  return (store) => (next) => (action) => {
    switch (action.type) {
      /*
       *  START_ONLOAD_LIVE_QUERY action should be dispatched only once i.e. on page load. Dispatched in ExpertPortalContainer.js --> mapDispatchToProps -> onLoad
       */
      case START_ONLOAD_LIVE_QUERY:
        startAssignedLiveQuery(store);
        startAllLiveQuery(store);
        startEscalatedLiveQuery(store);
        startBusinessDetailLiveQuery(store);
        startReviewTicketsQuery(store);
        startDecisionFlowLiveQuery(store);

        const nominatedLiveQueryPromise = startNominatedLiveQuery(store);
        const result = next(action);

        // returns promise so that caller of dispatch() has a handle on the opening of the nominated live query connection
        return nominatedLiveQueryPromise.then(() => result); // todo:
      /*
       *  START_ALL_TICKET_LQ action is dispatched:
       *      1) on page load with default Ticket Status & Expert Id
       *      2) when the Specialist changes the Ticket Status or Expert filter on All Ticket tab.
       */
      case START_ALL_TICKET_LQ:
        startAllLiveQuery(store);

        return next(action);

      case START_ESCALATED_TICKET_LQ:
        startEscalatedLiveQuery(store);

        return next(action);

      /*
       *  LOAD_CONVERSATION action is dispatched:
       *      1) on page load with default tab's first ticket (if exists)
       *      2) when Expert/Specialist selects a different ticket
       *
       *   We un-subscribe to the old conversation and subscribe to the new conversation
       */
      case LOAD_CONVERSATION:
      case SHOW_CONVERSATION:
        startConversationLiveQuery(store, action?.conversation?.selectedConversationId);

        return next(action);

      /*
       *    LOAD_LONG_TRANSACTION action is dispatched:
       *      1) When a long transaction is triggered like cancelling a order.
       *
       *    In this action we want to wait for the transaction to get a response and update the table.
       */

      case LOAD_LONG_TRANSACTION:
        startLongTransactionLiveQuery(store);

        return next(action);
      default:
        return next(action);
    }
  };
};

export { liveQueryMiddleware };
